import { z } from 'zod';
import { CateringEventCategoryModelSchema } from 'entities/catering-event-category';
import { GetCateringEventCategoriesApiResponseSchema } from '../store';

export const createCateringEventCategoriesFromGetCateringEventCategoriesApiResponse = (
    (response: z.infer< typeof GetCateringEventCategoriesApiResponseSchema>) => (
        response.data.map(({
            name,
            slug,
        }) => (
            CateringEventCategoryModelSchema.parse({
                uid: slug,
                name,
                slug,
            })
        ))
    )
);
